import { render, staticRenderFns } from "./ApprovalAgent.vue?vue&type=template&id=06c75c1e"
import script from "./ApprovalAgent.vue?vue&type=script&lang=js"
export * from "./ApprovalAgent.vue?vue&type=script&lang=js"
import style1 from "./ApprovalAgent.vue?vue&type=style&index=1&id=06c75c1e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports